import { Alert, Button, Dialog, Portal, Text, VStack } from '@chakra-ui/react'

type Props = {
  isOpen: boolean
  onClose: () => void
  onSendAndClose: () => Promise<void> | void
  loading?: boolean
  error?: string | null
  recipientLabel?: string // "Max Mustermann (max@ex.com)"
}

export function CancellationCreatedDialog({
  isOpen,
  onClose,
  onSendAndClose,
  loading,
  error,
  recipientLabel,
}: Props) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={details => {
        if (!details.open) onClose()
      }}
      size="md"
      closeOnInteractOutside={false}
      closeOnEscape={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Stornorechnung wurde erstellt</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <VStack align="stretch" gap="4">
                <Text>
                  Die Stornorechnung wurde erstellt und unter „Rechnungen“ gespeichert. Sie wurde
                  noch nicht an den Rechnungsempfänger versandt.
                </Text>

                <Text>
                  Möchten Sie die Stornorechnung direkt{' '}
                  {recipientLabel ? (
                    <>
                      an <b>{recipientLabel}</b>
                    </>
                  ) : (
                    'an den Rechnungsempfänger'
                  )}{' '}
                  versenden?
                </Text>

                {error ? (
                  <Alert.Root status="error">
                    <Alert.Indicator />
                    <Alert.Description>{error}</Alert.Description>
                  </Alert.Root>
                ) : null}
              </VStack>
            </Dialog.Body>

            <Dialog.Footer>
              <Button variant="outline" onClick={onClose} disabled={!!loading}>
                Schließen
              </Button>

              <Button colorPalette="gray" loading={!!loading} onClick={onSendAndClose}>
                Jetzt versenden
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
